import React, { useState, useEffect } from 'react';

import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import SacScoreBar from 'components/SacScoreBar';
import ProtocolPainel from 'components/ProtocolPainel';

import ScoreBarSevice from 'services/scoreBar.service';
import SacScoreBall from 'components/SacScoreBall';

const MenuSac = () => {
  const _scoreBarService = new ScoreBarSevice();

  const [scoreBar, setScoreBar] = useState(0);
  const [score, setScore] = useState(0);

  useEffect(() => {
    _scoreBarService.GetScore().then((response) => {
      setScore(response);
      setScoreBar(response * 20);
    });
  }, []);

  return (
    <Row
      className="flex-1 w-md-100 mx-md-auto flex-md-wrap"
      style={{ marginTop: -40, alignItems: 'flex-end' }}
    >
      <Column className="justify-end w-40 w-md-80 pr-2 px-md-4 mt-md-3 order-md-2">
        <Row className="align-center w-100 justify-between flex-sm-column justify-sm-none align-sm-none">
          <Text size={24} className="font-bold color-primary">
            Qualificações
          </Text>
          <Text size={12} className="color-blue-gray font-italic">
            Resumo das avaliações dos últimos 30 dias
          </Text>
        </Row>
        <SacScoreBar score={scoreBar} />
      </Column>
      <Column className="w-md-20 order-md-3">
        <SacScoreBall score={score} />
      </Column>
      <ProtocolPainel />
    </Row>
  );
};

export default MenuSac;
